import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import { BaseComponent, BottoneAPI, ChiamaAPI, Trad } from '../components/';

interface IFideCodiceControllo {
    polizza: Dati.CRisAPI_DatiPolizzaCodiceControllo;
}

export class FideCodiceControllo extends BaseComponent<Glob.IRouteGlobaleProps, IFideCodiceControllo> {
    constructor(props: any) {
        super(props);
        let polizza: Dati.CRisAPI_DatiPolizzaCodiceControllo = new Dati.CRisAPI_DatiPolizzaCodiceControllo();
        polizza.CodiceControllo = (this.props.match.params as any).CodiceControllo;
        polizza.Polizza = (this.props.match.params as any).Polizza;
        this.state = { polizza: polizza };

        this.OnClickControllo = this.OnClickControllo.bind(this);
        this.OnErroreBottoneAPI = this.OnErroreBottoneAPI.bind(this);
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    private OnClickControllo(sender: BottoneAPI, dati: Dati.CRisAPI_DatiPolizzaCodiceControllo) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            this.setState({ polizza: dati });
        }
    }

    private AggiornaCodiceControllo(valore: string) {
        let pol = this.state.polizza;
        pol.CodiceControllo = valore;
        this.setState({ polizza: pol });
    }

    private AggiornaPolizza(valore: string) {
        let pol = this.state.polizza;
        pol.Polizza = valore;
        this.setState({ polizza: pol });
    }

    public render() {

        return <div className="kt-grid kt-grid--hor kt-grid--root kt-page">
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver-desktop kt-grid--desktop kt-grid--tablet-and-mobile kt-grid--hor-tablet-and-mobile kt-login kt-login--1 kt-login--signin" id="kt_login">
                <div className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-login__aside">
                    <div className="kt-stack kt-stack--hor kt-stack--desktop">
                        <div className="kt-stack__item kt-stack__item--fluid">
                            <div className="kt-login__wrapper">
                                <div className="kt-login__logo">
                                    <a href="#">
                                        <img src="/images/logoInAR.png" />
                                    </a>
                                </div>

                                <div className="kt-login__signin">
                                    <div className="kt-login__head">
                                        <h3 className="kt-login__title">{Trad.Trad("Controllo validità fideiussione")}</h3>

                                    </div>

                                    <form className="kt-login__form kt-form login-form" action="">
                                        <div className="form-group kt-form login-form__group">
                                            <input className="form-control kt-input" placeholder={Trad.Trad("NumeroPolizza")} name="Polizza" value={this.state.polizza.Polizza} type="text" onChange={(e) => { this.AggiornaPolizza(e.currentTarget.value) }} />
                                        </div>
                                        <div className="form-group kt-form login-form__group">
                                            <input className="form-control kt-input" placeholder={Trad.Trad("Codice controllo")} name="CodiceControllo" value={this.state.polizza.CodiceControllo} type="text" onChange={(e) => { this.AggiornaCodiceControllo(e.currentTarget.value) }} />
                                        </div>
                                        <div className="kt-login__form-action">
                                            <BottoneAPI Default Testo={Trad.Trad("Verifica")} URL={"/api/Polizza/ControlloCodiceControllo?codiceControllo=" + this.state.polizza.CodiceControllo + "&polizza=" + this.state.polizza.Polizza} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} OnClick={(s, d) => this.OnClickControllo(s, d)} />
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--center kt-grid--hor kt-grid__item--order-tablet-and-mobile-1	m-login__content" style={{ backgroundImage: 'url(/images/sfondo_controlli.jpg)' }}>
                    <div className="kt-grid__item kt-grid__item--middle">
                        <h3 className="kt-login__welcome">{Trad.Trad("Dati Fideiussione")}</h3>
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-6 col-form-label kt-login__msg">{Trad.Trad("Codice controllo")}:</label>
                            <label className="col-lg-6 col-form-label kt-login__msg">{this.state.polizza.CodiceControllo}</label>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-6 col-form-label kt-login__msg">{Trad.Trad("Polizza")}:</label>
                            <label className="col-lg-6 col-form-label kt-login__msg">{this.state.polizza.Polizza}</label>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-6 col-form-label kt-login__msg">{Trad.Trad("Contraente")}:</label>
                            <label className="col-lg-6 col-form-label kt-login__msg">{this.state.polizza.Contraente}</label>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-6 col-form-label kt-login__msg">{Trad.Trad("Beneficiario")}:</label>
                            <label className="col-lg-6 col-form-label kt-login__msg">{this.state.polizza.Beneficiario}</label>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-6 col-form-label kt-login__msg">{Trad.Trad("Importo garantito")}:</label>
                            <label className="col-lg-6 col-form-label kt-login__msg">{this.state.polizza.ImportoGarantito}</label>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-6 col-form-label kt-login__msg">{Trad.Trad("Data emissione")}:</label>
                            <label className="col-lg-6 col-form-label kt-login__msg">{this.state.polizza.DataEmissione.toLocaleDateString()}</label>
                        </div>
                    </div>
                </div>
            </div>


        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/form/FideCodiceControllo.tsx